module.exports = __webpack_public_path__ + "img/23-small.f489333c.png";